export default "__VITE_ASSET__c5e4a88d__"